import React, { useState } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { useNavigate } from 'react-router-dom';
import successToast from '../../components/toasts/successToast';
import { useDispatch } from 'react-redux';
import errorToast from '../../components/toasts/errorToast';
import { addDocumentsAction, uploadFile } from '../../redux/actions/documentAction';
import { availableLanguages } from '../../components/data/languageData';
import { getNumPages } from '../../components/translationHelpers/document.helper';
import { IoArrowBack } from 'react-icons/io5';
import { Spinner } from 'react-bootstrap';

const UploadDocument = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isFolderMode, setIsFolderMode] = useState(false);
  const [loading, setLoading] = useState(false);
  const [uploading, setUploading] = useState(false);

  const onError = (error) => {
    errorToast(error.data.message);
    setLoading(false);
  };


  const handleFileChange = async (event, setFieldValue) => {
    const files = event.target.files;
    let uploadedFiles = [];

    for (let file of files) {
      try {
        setUploading(true)
        // const numPages = await getNumPages(file); // Get the number of pages for each file
        await new Promise((resolve, reject) => {
          const onSuccess = async (data) => {
            const numPages = data.data.data.pageCount ?? await getNumPages(file);
            console.log(numPages, "num of pages");

            uploadedFiles.push({ ...data.data.data, no_of_pages: numPages });
            resolve();
          };

          const onError = (error) => {
            console.error(`Error uploading: ${file.name}`, error);
            errorToast(error.data.message);
            reject(error);
          };

          dispatch(uploadFile(file, onSuccess, onError));
        });
      } catch (error) {
        console.error('Error uploading file', error);
      } finally {
        setUploading(false)
      }
    }

    console.log(uploadedFiles, "Uploaded files array with page counts");
    setFieldValue('document', uploadedFiles);
  };

  const initialValues = {
    document: null,
    folder: null,
    source_lang: "",
    comments: "",
  };

  const validationSchema = Yup.object().shape({
    document: Yup.mixed()
      .test('fileSelected', 'At least one file is required', (value) => {
        return value && value.length > 0;
      })
      .required('Required'),
    source_lang: Yup.string().required('Required'),
  });

  const onSubmit = (values) => {
    console.log("form values", values);
    setLoading(true);
    dispatch(addDocumentsAction(values, onSuccess, onError));
  };

  const onSuccess = (data) => {
    successToast(data?.data?.message);
    setLoading(false);
    navigate('/documents')
  }
  return (
    <div className="d-flex vh-100">
      <div className="w-100">

        <div className='w-100 d-flex gap-1 align-items-center header border-bottom position-sticky top-0 bg-white py-2 mt-1'>
          <span className="px-1 fs_16 cursor_pointer" onClick={() => navigate(-1)}><IoArrowBack /></span>
          <h2 className="fs_20 fw_400 fn_Roboto text-start px-2">Upload Document</h2>
        </div>
        <div className="flex-grow-1 pt-3">
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
          >
            {({ values, setFieldValue, dirty }) => (
              <Form className="d-flex flex-column h-100 justify-content-between">
                <div>
                  <div className="text-start gap-3 mb-2 text-nowrap mx-4">
                    <label htmlFor="document" className="py-1">Document / Folder </label>
                    <div className="d-flex align-items-center gap-2">
                      <input
                        type="checkbox"
                        checked={isFolderMode}
                        onChange={(e) => setIsFolderMode(e.target.checked)}
                      />
                      <label>Select Folder</label>
                    </div>

                    <div className="d-flex position-relative">
                      <input
                        type="file"
                        accept=".pdf, .docx, .pptx, .html"
                        id="document"
                        name="document"
                        style={{ width: '20rem' }}
                        onChange={(event) => handleFileChange(event, setFieldValue)}
                        className="input-field cursor_pointer"
                        webkitdirectory={isFolderMode ? 'true' : undefined}
                      />
                    </div>
                    <span className='fs_14 fw_400 text-black-50 '>{
                      uploading ? "Uploading..." : "Note: Only PDF, DOCX, PPTX and HTML file formats are supported."}</span>
                    <ErrorMessage name="document" component="div" className="text-danger mt-1 fs_12" />
                  </div>

                  <div className="text-start gap-3 mb-2 text-nowrap mx-4">
                    <label htmlFor="team_lead" className="py-1">Source Language</label>
                    <div className="d-flex position-relative">
                      <Field
                        as="select"
                        id="source_lang"
                        name="source_lang"
                        className="input-field"
                        style={{ width: '20rem' }}
                      >
                        <option value="">Select Source Language</option>
                        {availableLanguages.map((language) => (
                          <option key={language.value} value={language.value}>
                            {language.label}
                          </option>
                        ))}
                      </Field>
                    </div>
                    <ErrorMessage name="source_lang" component="div" className="text-danger mt-1 fs_12" />
                  </div>
                  <div className="text-start gap-3 mb-2 text-nowrap mx-4">
                    <label htmlFor={`comments`} className="py-1">Description</label>
                    <div className="d-flex position-relative">
                      <Field
                        name={`comments`}
                        as="textarea"
                        className="input-field"
                        id={`comments`}
                        style={{ width: '20rem' }}
                      />
                    </div>
                    <ErrorMessage name={`comments`} component="div" className="text-danger mt-1 fs_12" />
                  </div>
                </div>
                <div className="d-flex gap-5 mt-4 mx-4 my-3">
                  <button
                    type="submit"
                    className="btn btn-primary cursor_pointer"
                    style={{ minWidth: '6rem' }}
                    disabled={!dirty || loading}
                  >
                    <div className='fs_12 d-flex gap-2 justify-content-center'>
                      {loading ? <Spinner size="sm" className="mt-1" /> : ""}
                      <label className="fs_16">{!loading ? 'Upload' : 'Uploading'}</label>
                    </div>
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary cursor_pointer"
                    style={{ width: '5rem' }}
                    onClick={() => navigate('/documents')}
                  >
                    Cancel
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
};

export default UploadDocument;
